import { render, staticRenderFns } from "./TeleMarketAttachment.vue?vue&type=template&id=e3abcefa&scoped=true"
import script from "./TeleMarketAttachment.vue?vue&type=script&lang=js"
export * from "./TeleMarketAttachment.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketAttachment.vue?vue&type=style&index=0&id=e3abcefa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3abcefa",
  null
  
)

export default component.exports